<template>
    <iframe
        ref="iFrameEl"
        :data-component="$options.name"
        :src="iFrameUrl"
        class="w-full border-0 overflow-hidden"
        style="height: 1721px"
        title="RealEstate iFrame"
    />
</template>
<script lang="ts" src="./HydratedRealEstateIframe.ts" />
